import React from 'react'
import Markdown from 'react-markdown';
import './style.css';
import contributors from '../../assets/cms/contributors.json';
import { Link } from 'react-router-dom';
import OptimisedImage from '../../SharedComponents/OptimisedImage';

export class Category extends React.Component {
  render () {
    return <div style={{
      backgroundColor: '#00A651',
      color: 'white',
      fontSize: 16,
      borderRadius: 5,
      float: 'right',
      padding: 5,
      margin: 5
    }}>
      {this.props.name}
    </div>
  }
}

class Article extends React.Component {
  render() {
    const article = this.props.article;
    if (article) {
      return (
        <div className="centered-content article">
          <div style={{
            marginTop: 10,
            marginBottom: 10,
            overflow: 'hidden',
          }}>
            <h1 style={{
              width: 'auto',
              float: 'left',
              margin: 10,
            }} className="article-heading">{article.term}</h1>
            <div style={{
              float: 'right',
              margin: 10,
            }} className="article-categories">
              {article.categories.map((category) => {
                return <Category key={category} name={category} />
              })}
            </div>
          </div>
            <OptimisedImage
              image={require("../../assets/cms/images/__assets__/" + article.image + ".js")}
              alt={""}
              className="header-image"
            />
            <Markdown
              escapeHtml={false}
              source={article.description}
            />
            {
              article.references && article.references.length > 0 && <section className="article-references">
                <h1>References</h1>
                <ul>
                  {
                    article.references.map(({ title, url }, index) => <li key={index}>{title} — <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></li>)
                  }
                </ul>
              </section>
            }
            <section className="article-contributors">
              <h3>People who contributed to this article:</h3>
              {article.contributors.map((c) => {return(<Link  key={c} to={"/contributors/" + contributors[c].tag}><p style={{color:'#00A651'}}>{contributors[c].name}</p></Link>);})}
            </section>
        </div>
      )
    } else {
      return (
        <div className="centered-content">
          <h1>This article hasn't been written yet</h1>
          <p>Think you could write it? Visit the Contact Us page and get in touch.</p>
        </div>
      )
    }

  }
}

export default Article;